import { createContext } from "react";
export const ContentReadyContext = createContext(undefined);
